import connectionTypes from '../connectionTypes';
import IAP_DEVICE_FEATURE_CODES from './iapDeviceFeatureCodes';

export const IAP_DEVICE_MODEL_NAMES = {
    MERCURY_W_LCD_C: 'MERCURY_W_LCD_C',
    MERCURY_L_LCD_C: 'MERCURY_L_LCD_C',
    ORION: 'ORION',
};

// IAP dropped its WiFi/LTE setup codes — only the model name tells them apart; keys must match IAP.
// `connectionType` = the transport the model is set up over, not every transport it speaks.
const IAP_DEVICE_MODELS = {
    [IAP_DEVICE_MODEL_NAMES.MERCURY_W_LCD_C]: {
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I2,
        connectionType: connectionTypes.WIFI,
    },
    [IAP_DEVICE_MODEL_NAMES.MERCURY_L_LCD_C]: {
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I2,
        connectionType: connectionTypes.CELLULAR,
    },
    [IAP_DEVICE_MODEL_NAMES.ORION]: {
        deviceFeatureCode: IAP_DEVICE_FEATURE_CODES.ILUMA_I5,
        connectionType: connectionTypes.WIFI,
    },
};

export default IAP_DEVICE_MODELS;
